import { Concept } from "@meta-press/shared-plugins";

export class ArticleConceptRequest {
	public article = "";
	public concepts: Concept[] = [];
}
